import React, { useState, useEffect, useRef } from "react";
import { BiMenu } from "@react-icons/all-files/bi/BiMenu";
import NavSocial from "./nav-social";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function NavHeaderLink({ to, children, className }) {
  return (
    <Link
      to={to}
      className={`text-black px-2 py-2 text-lg uppercase ${className}`}
    >
      {children}
    </Link>
  );
}

export default function NavHeader({ children }) {
  const [navbarOpen, setNavbarOpen] = useState(false);
  const [height, setHeight] = useState(0);
  const ref = useRef();
  const size = useWindowSize();

  const updateHeight = () => {
    if (!ref.current) return;
    setHeight(ref.current.scrollHeight);
  };

  useEffect(() => {
    updateHeight();
    window.addEventListener("resize", updateHeight);
  }, []);

  return (
    <header>
      <nav className="bg-white sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-2 sm:px-4 relative flex flex-col sm:flex-row sm:items-center justify-between">
          <div className="flex flex-1 hidden lg:block">
            <NavSocial className="text-black text-3xl" />
          </div>

          <div className="flex-grow-0 flex flex-row justify-between items-center">
            <Link to="/" className="contents">
              <StaticImage
                src="../images/lostwithlydia-tight.png"
                alt="Lost with Lydia logo"
                width={80}
                height={80}
                placeholder="tracedSVG"
              />
            </Link>

            <button
              id="nav-toggle"
              className="text-black px-2 py-2 text-4xl sm:hidden"
              onClick={() => setNavbarOpen(!navbarOpen)}
            >
              <BiMenu />
            </button>
          </div>

          <div
            ref={ref}
            className={`transition-[height] duration-100 ease-in-out overflow-hidden sm:flex-1`}
            style={{
              height: size.width > 640 ? undefined : navbarOpen ? height : 0,
            }}
          >
            <div
              id="nav-content"
              className={`flex sm:flex-1 sm:items-stretch sm:justify-end flex-col sm:flex-row space-y-4 sm:space-y-0 p-4 sm:space-x-2 sm:p-0 block`}
            >
              <NavHeaderLink to="/">Home</NavHeaderLink>
              <NavHeaderLink to="/about/">About</NavHeaderLink>
              <NavHeaderLink to="/tips/">Tips</NavHeaderLink>
              <NavHeaderLink to="/destinations/">Destinations</NavHeaderLink>
            </div>
          </div>
        </div>
      </nav>
      {children}
    </header>
  );
}

// Hook
function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return windowSize;
}
